import { Link, Route, Routes } from "react-router-dom";
import { Landing } from "./routes/Landing.js";
import { Captains } from "./routes/Captains.js";
import { Pilots } from "./routes/Pilots.js";
import { NotFound } from "./routes/NotFound.js";

export function App() {
  return (
    <div className="relative flex min-h-full flex-col">
      <header className="border-b border-void-800/70">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-6 py-4">
          <Link
            to="/"
            className="font-display text-sm font-semibold tracking-[0.2em] text-void-200 uppercase transition-colors hover:text-white"
          >
            Aetherstream <span className="text-void-400">Personnel</span>
          </Link>
          <nav className="flex gap-6 text-sm text-void-400">
            <Link to="/captains" className="transition-colors hover:text-leviathan-500">
              Captains
            </Link>
            <Link to="/pilots" className="transition-colors hover:text-interceptor-500">
              Pilots
            </Link>
          </nav>
        </div>
      </header>

      <main className="relative mx-auto w-full max-w-5xl flex-1 px-6 py-12">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/captains" element={<Captains />} />
          <Route path="/pilots" element={<Pilots />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="border-t border-void-800/70">
        <div className="mx-auto w-full max-w-5xl px-6 py-5 text-xs text-void-700">
          Records are held in this browser only. Nothing is uploaded.
        </div>
      </footer>
    </div>
  );
}
